/* INVOICES */
export const DIALOG_SHOW = "@DIALOG/DIALOG_SHOW";
export const DIALOG_UPDATE = "@DIALOG/DIALOG_UPDATE";
export const DIALOG_ACTION = "@DIALOG/DIALOG_ACTION";
export const DIALOG_CLOSE = "@DIALOG/DIALOG_CLOSE";
